import BottomCTA from './BottomCTA';
import FindServiceCenter from './FindServiceCenter';
import HowItWorks from './HowItWorks';
import ServiceCapabilities from './ServiceCapabilities';
import ServiceCoupons from './ServiceCoupons';
import ServiceFAQ from './ServiceFAQ';
import ServiceHero from './ServiceHero';
import TrustBar from './TrustBar';
import WhyServiceWithUs from './WhyServiceWithUs';

export default function ServiceLandingPage() {
  return (
    <>
      <ServiceHero />
      <TrustBar />
      <ServiceCoupons />
      <WhyServiceWithUs />
      <HowItWorks />
      <ServiceCapabilities />
      <ServiceFAQ />
      <FindServiceCenter />
      <BottomCTA />
    </>
  );
}
